import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";

var colors = ["#211C6A","#0593AA","#A98300","#944E63"];
const decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
    .map(hex => parseInt(hex, 16))
    .map(applySaltToChar)
    .map(charCode => String.fromCharCode(charCode))
    .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"))

class ConsignmentChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      plannedcount: 0,
      unplannedcount: 0,
      pendingcount: 0,

      total: 0,
      active: 0,
      delivered: 0,
      epod: 0,
      totalcount: 0,
      stoppages: 0,
      transitDelay: 0,
      ontimeDelivered: 0,
      epodPending: 0,
      overspeed:0
    };
  }

  componentDidMount() {
    this.getdata();
  }

  getdata = () => {
    redirectURL.post('/getConsignmentsData').then((resp) => {
      var records = resp.data;
      // console.log(records, "records30");
      if(records!='' && records!=undefined){
        if (decode(localStorageRole).toLowerCase()=== "tpt"){
          if(localStorage.getItem('tpt_code') !== '' && localStorage.getItem('tpt_code') !== undefined){
            records = records.filter(e=>e.transporter_code == localStorage.getItem('tpt_code'))
          }
        }
        if (decode(localStorageRole).toLowerCase()=== "warehouse"){
          if(localStorage.getItem('warehouse_code') !== '' && localStorage.getItem('warehouse_code') !== undefined){
            records = records.filter(e=>e.consignee_code === localStorage.getItem('warehouse_code'))
          }
        }
      }
     
     

      var active = records.filter((e) => e.status === 2 || e.status === 3);
      var delivered = records.filter((e) => e.status !== 2 && e.status !== 3);
      var total = records.filter((e) => e.status !== "" && e.status !== undefined)
      var epod = records.filter((e) => e.epod_check === 1);

      // console.log(active, delivered, total, "36");

      var stoppages = 0;
      var transitDelay = 0;
      var ontimeDelivered = 0;
      var epodPending = 0;
      var overspeed = 0;

      if (total !== '' && total !== undefined) {
        stoppages = total.filter((e) => e.enroute_exception === 1).length
        transitDelay = total.filter((e) => e.transit_delay === 1).length
        ontimeDelivered = total.filter((e) => e.ontime_status === 1).length
        epodPending = total.filter((e) => e.epod_check === 1 && e.process_epod !== 1).length
        overspeed = total.filter((e) => e.overspeeding_exception === 1).length
      }

      var data = [
        { name: 'Active', y: active.length },
        { name: 'Delivered', y: delivered.length },
        // {name: "E POD", y: epod.length }
      ];
      this.setState({ 
        series: data,
        total: total,
        active: active,
        delivered: delivered,
        epod: epod,

        stoppages: stoppages,
        transitDelay: transitDelay,
        ontimeDelivered: ontimeDelivered,
        epodPending: epodPending,
        overspeed: overspeed
      },
        ()=>{
          // console.log("series ", this.state.series)
          this.renderChart();
        }); 
    });
  }

  componentDidUpdate() {
    this.renderChart();
  }

  renderChart = () => {
    const totalCount = this.state.total.length;

    Highcharts.chart('container-c', {
      chart: {
        type: 'pie',
        custom: {},
        events: {
          render: function() {
            const chart = this,
              series = chart.series[0];
            let customLabel = chart.customLabel;
            let customTotalLabel = chart.customTotalLabel;

            if (!customLabel) {
              customLabel = chart.customLabel =
                chart.renderer.label(
                  'Consignments'
                )
                  .css({
                    color: '#000',
                    textAnchor: 'middle'
                  })
                  .add();
            }

            if (!customTotalLabel) {
              customTotalLabel = chart.customTotalLabel =
                chart.renderer.label(
                  totalCount
                )
                  .css({
                    color: '#000',
                    textAnchor: 'middle'
                  })
                  .add();
            }

            const x = series.center[0] + chart.plotLeft,
              y = series.center[1] + chart.plotTop - customLabel.attr('height') / 2;

            customLabel.attr({
              x,
              y
            });

            customTotalLabel.attr({
              x,
              y: y + 20
            });

            customLabel.css({
              fontSize: `${series.center[2] / 12}px`
            });

            customTotalLabel.css({
              fontSize: `${series.center[2] / 10}px`
            });
          }
        }
      },
      accessibility: {
        point: {
          valueSuffix: ''
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y:.0f} <b>({point.percentage:.0f}%)</b>'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          borderRadius: 8,
          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: '{point.name}'
            },
            {
              enabled: true,
              distance: -15,
              format: '{point.y:.0f}',
              style: {
                fontSize: '0.9em'
              }
            }
          ],
          showInLegend: true
        }
      },
      colors: colors,
      series: [{
        name: 'Orders',
        colorByPoint: true,
        innerSize: '75%',
        data: this.state.series,
      }],
      credits: false
    });
  };

  render() {
    return (
      <div className="card row">
        <div className="card-body">
          <div className="d-flex flex-row justify-content-between align-items-center w-100 pb-2 pr-5">
            <div className="ml-4 mt-2 font-weight-bold d-flex flex-row justify-content-center align-items-baseline" >
              <span className="ml-2 f18">PTL Summary</span>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
            {/* <div className='col-sm-6'>
              <div id="container-c" style={{ height: '300px', width: '100%' }}></div>
            </div> */}
            <div className='col-sm-6'>
              <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
                <ul className="chart-info">
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[3],cursor:'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?"+'Total'}>
                    Total
                    <span>{this.state.total.length}</span>
                  </li >
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[0],cursor:'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?"+'Active'}>
                    Active
                    <span>{this.state.active.length}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[1],cursor:'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?"+'Delivered'}>
                    Delivered
                    <span>{this.state.delivered.length}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[2],cursor:'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?"+'Epod'}>
                    E POD
                    <span>{this.state.epod.length}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
              <div className="row">
              <div className="col  card card-bx">
                  <div className="card-body" style={{ color: colors[0] }}>
                    Overspeed
                    <div className="">
                      {this.state.overspeed}
                    </div>
                  </div>
                </div>

                <div className="col  card card-bx">
                  <div className="card-body" style={{ color: colors[0] }}>
                    Stoppages
                    <div className="">
                      {this.state.stoppages}
                    </div>
                  </div>
                </div>

                <div className="col  card card-bx">
                  <div className="card-body" style={{ color: colors[0] }}>
                    Transit Delay
                    <div className="">
                      {this.state.transitDelay}
                    </div>
                  </div>
                </div>

                <div className="col  card card-bx">
                  <div className="card-body" style={{ color: colors[0] }}>
                    Ontime Delivered
                    <div className="">
                      {this.state.ontimeDelivered}
                    </div>
                  </div>
                </div>
                <div className="col  card card-bx">
                  <div className="card-body" style={{ color: colors[0] }}>
                    EPOD Pending
                    <div className="">
                      {this.state.epodPending}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsignmentChart;
